import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import I18nProvider from './components/providers/I18nProvider';
import ProtectedRoute from './components/auth/ProtectedRoute';
import PWAUpdatePrompt from './components/common/PWAUpdatePrompt';

// Route components
import Landing from './routes/Landing';
import Login from './routes/Login';
import LoginCallback from './routes/LoginCallback';
import Register from './routes/Register';
import ForgotPassword from './routes/ForgotPassword';
import Dashboard from './routes/Dashboard';
import Settings from './routes/Settings';
import Profile from './routes/Profile';
import PrivacyPolicy from './routes/PrivacyPolicy';
import LegalNotice from './routes/LegalNotice';
import TermsOfService from './routes/TermsOfService';

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route path="/p/:publicId" element={<Profile />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/legal" element={<LegalNotice />} />
            <Route path="/terms" element={<TermsOfService />} />
            {/* Catch-all for 404 - redirect to home */}
            <Route path="*" element={<Landing />} />
          </Routes>
          <PWAUpdatePrompt />
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}
